export default __webpack_public_path__ + "static/creare-mvp-vincente-2915e8443d23559edbdaa9b2fa70ae9f.jpg";